/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Trans, withTranslation } from 'react-i18next';
import {
  Button,
  Dimmer,
  Dropdown,
  Grid,
  Loader,
  Menu,
  Segment,
  Label,
} from 'semantic-ui-react';
import qs from 'qs';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import { fetchTags } from '../actions/tags';
import valueToText from '../utils/valueToText';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

import LoadImage from './LoadImage';
import PageNav from './PageNav';

class GalleryList extends Component {
  static propTypes = {
    pictures: PropTypes.arrayOf(PropTypes.object),
    tabular: PropTypes.bool,
    projectID: PropTypes.string,
    unitLayoutID: PropTypes.string,
    loading: PropTypes.bool,
    onViewLarge: PropTypes.func,
    onAdd: PropTypes.func,
    onChange: PropTypes.func,
    addPath: PropTypes.string,
    addVideoPath: PropTypes.string,
    editable: PropTypes.bool,
    excludeType: PropTypes.arrayOf(PropTypes.string),
    tags: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    tags: state.tags.data && state.tags.data.picture ? state.tags.data.picture : [],
  })
  constructor(props) {
    super(props);
    let tabs = [
      { text: props.t('General'), name: 'general', value: 'general' },
      { text: props.t('Site Plan'), name: 'site_plan', value: 'site_plan' },
      { text: props.t('Unit Layout'), name: 'unit_layout', value: 'unit_layout' },
      { text: props.t('Map'), name: 'map', value: 'map' },
      { text: props.t('Video'), name: 'video', value: 'video' },
    ];
    if (props.excludeType && props.excludeType.length > 0) {
      tabs = tabs.filter(tab => !props.excludeType.some(ex => ex === tab.name));
    }
    if (!props.editable && props.pictures && props.pictures.length > 0) {
      tabs = tabs.filter(tab => props.pictures.some(p => p.type === tab.name));
    }
    const currentTab = tabs && tabs[0] ? tabs[0].name : '';
    this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      searchTag: '',
      tabs,
      currentTab,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchTags('picture', true));
  }
  componentDidMount() {
    if (this.state.currentTab === 'video') {
      this.fetchMedias();
    } else {
      this.fetchPictures();
    }
  }
  componentWillReceiveProps(nextProps) {
    const loading = nextProps.loading;
    if (loading !== undefined) {
      this.setState({ loading });
    }
    // Update tabs when language changes (t function changes)
    if (nextProps.t !== this.props.t) {
      this.updateTabs(nextProps.t);
    }
  }
  updateTabs(t) {
    let tabs = [
      { text: t('General'), name: 'general', value: 'general' },
      { text: t('Site Plan'), name: 'site_plan', value: 'site_plan' },
      { text: t('Unit Layout'), name: 'unit_layout', value: 'unit_layout' },
      { text: t('Map'), name: 'map', value: 'map' },
      { text: t('Video'), name: 'video', value: 'video' },
    ];
    if (this.props.excludeType && this.props.excludeType.length > 0) {
      tabs = tabs.filter(tab => !this.props.excludeType.some(ex => ex === tab.name));
    }
    if (!this.props.editable && this.props.pictures && this.props.pictures.length > 0) {
      tabs = tabs.filter(tab => this.props.pictures.some(p => p.type === tab.name));
    }
    this.setState({ tabs });
  }
  setData(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
        if (this.props.onChange) {
          this.props.onChange(data);
        }
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getThumbnailUrl = (media) => {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  }
  async fetchMedias() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = {
      page: this.state.currentPage || 1,
      type: 'video',
      oembed: true,
    };
    const projectURL = this.props.projectID ? `/projects/${this.props.projectID}` : '';
    const layoutURL = this.props.unitLayoutID ? `/unit_layouts/${this.props.unitLayoutID}` : '';
    const url = projectURL.concat(layoutURL, `/medias/?${qs.stringify(query)}`);
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setData(data);
      if (this.state.data.length < 1 && query.page > 1) {
        this.setState({ currentPage: 1 }, () => {
          this.fetchMedias();
        });
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  async fetchPictures() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      page: this.state.currentPage || 1,
      tab: this.state.currentTab ||
      (this.props.tabs && this.props.tabs.length > 0 ? this.props.tabs[0].name : 'general'),
      search: this.state.currentTab === 'general' ? this.state.searchTag : '',
    });
    const projectURL = this.props.projectID ? `/projects/${this.props.projectID}` : '';
    const layoutURL = this.props.unitLayoutID ? `/unit_layouts/${this.props.unitLayoutID}` : '';
    const url = projectURL.concat(layoutURL, `/pictures/?${qs.stringify(query)}`);
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setData(data);
      if (this.state.data.length < 1 && query.page > 1) {
        this.setState({ currentPage: 1 }, () => {
          this.fetchPictures();
        });
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, () => {
      this.fetchPictures();
    });
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab }, () => {
      if (currentTab === 'video') {
        this.fetchMedias();
      } else {
        this.fetchPictures();
      }
    });
  }
  handleViewLarge = (e, data, type) => {
    if (this.props.onViewLarge) {
      this.props.onViewLarge(e, data, type);
    }
  }
  handleOnAdd = (e) => {
    if (this.props.onAdd) {
      this.props.onAdd(e);
    }
  }
  checkTabular() {
    if (this.props.editable) {
      return this.state.data.length > 0 ? 5 : 1;
    }
    return 5;
  }
  handleOnTagClick = (searchTag = '') => {
    this.setState({ searchTag }, () => {
      this.fetchPictures();
    });
  }
  checkTagSelected = (value) => {
    const { searchTag } = this.state;
    if (value === 'All') {
      return searchTag === '';
    }
    return searchTag === value;
  }
  renderTags = () => {
    const { tags, t } = this.props;
    const { currentTab } = this.state;
    if (tags.length > 0 && currentTab === 'general') {
      const newTags = [{ name: 'All' }].concat(tags);
      return (
        <Label.Group style={{ marginBottom: '1em' }}>
          {
            newTags.map((nt, idx) => (
              <Label
                key={idx}
                as="a"
                onClick={() => this.handleOnTagClick(nt.name === 'All' ? '' : nt.name)}
                color={this.checkTagSelected(nt.name) ? 'blue' : null}
              >
                {nt.name === 'All' ? t('All', { ns: TRANSLATION_FILES.translation }) : nt.name}
              </Label>
            ))
          }
        </Label.Group>
      );
    }
    return null;
  }
  renderContent() {
    const { t } = this.props;
    const { data, tabs, currentTab, loading } = this.state;
    const pictureNode = data.map((item, key) => {
      if (currentTab === 'video') {
        return (
          <Grid.Column textAlign="center" key={key}>
            <LoadImage
              as="a"
              size="small"
              shape="rounded"
              onClick={e => this.handleViewLarge(e, item, 'video')}
              src={this.getThumbnailUrl(item)}
              isVideo
            />
            <p
              style={{
                margin: '0.5em 1em 0',
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '0.9em',
              }}
              onClick={e => this.handleViewLarge(e, item, 'video')}
            >
              {item.label}
            </p>
          </Grid.Column>
        );
      }
      return (
        <Grid.Column textAlign="center" key={key}>
          <LoadImage
            as="a"
            size="small"
            shape="rounded"
            onClick={e => this.handleViewLarge(e, item, 'picture')}
            picture={item}
            pictureSize={30}
          />
        </Grid.Column>
      );
    });
    const tab = valueToText(tabs, currentTab).toLowerCase();
    return data.length > 0 ? pictureNode : (
      <Grid.Column width="16">
        <Segment textAlign="center" vertical>
          <Trans ns={TRANSLATION_FILES.screens}>
            {
              currentTab === 'video' ? (
                <p>No videos found.</p>
              ) : (
                <p>No {{ tab }} pictures found.</p>
              )
            }
          </Trans>
          {
            this.props.editable && (this.props.onAdd || this.props.addPath || this.props.addVideoPath) ?
              <Button
                as={this.props.addPath || this.props.addVideoPath ? Link : 'a'}
                primary compact
                disabled={loading}
                onClick={this.handleOnAdd}
                to={currentTab === 'video' && this.props.addVideoPath ? this.props.addVideoPath : this.props.addPath}
              >
                {t('Click here to add')}
              </Button>
            : null
          }
        </Segment>
      </Grid.Column>
    );
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        <Menu
          fluid
          attached="top"
          tabular={this.props.tabular}
        >
          {
            this.props.tabular ?
            this.state.tabs.map((tab, key) => (
              <Menu.Item
                key={key}
                name={tab.name}
                onClick={this.handleChangeTab}
                active={this.state.currentTab === tab.name}
              >{tab.text}</Menu.Item>
            )) : (
              <Dropdown
                item
                selectOnBlur={false}
                options={this.state.tabs}
                onChange={this.handleChangeTab}
                value={this.state.currentTab}
                disabled={this.state.loading}
                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
              />
          )}
          <Menu.Menu position="right">
            <PageNav
              attached="top"
              size="small"
              currentPage={this.state.currentPage}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
              dataSize={this.state.data.length}
              loading={this.state.loading}
              onChange={this.handleChangePage}
              noScrollTop
            />
          </Menu.Menu>
        </Menu>
        <Segment attached="bottom">
          {this.renderTags()}
          <Grid
            doubling={this.state.data.length > 0}
            columns={this.checkTabular()}
            verticalAlign="middle"
          >
            <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </Dimmer>
            {this.renderContent()}
          </Grid>
        </Segment>
      </div>
    );
  }
}

export default withTranslation(namespaces)(connect(
  GalleryList.mapStateToProps, null, null, { withRef: true },
)(GalleryList));



// WEBPACK FOOTER //
// ./src/components/GalleryList.jsx